import React from "react";
import styled from "styled-components";
import Loader from "../Loader/Loader";

const StyledOverlay = styled.div`
    background-color: rgba(0, 0, 0, 0.8);
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 10000;

    div {
        z-index: 10001;
    }
`;

const Overlay = ({ show, message, error }) => {
    if (show) {
        return (
            <StyledOverlay className="flex justify-center flex-col items-center">
                <div className="flex justify-center items-center py-4">
                    {!error && <Loader />}
                    <h1 className="text-white text-center">{message}</h1>
                </div>
            </StyledOverlay>
        );
    } else {
        return null;
    }
};

export default Overlay;
